export const FIELD_TIMING_CONSTANTS = {
    DEBOUNCE_DELAY_MS: 300,
    BLUR_DELAY_MS: 120,
    MULTI_BLUR_DELAY_MS: 150,
    OPTION_SELECT_RESET_DELAY_MS: 200,
    REFOCUS_DELAY_MS: 100,
    MULTI_FIELD_SETUP_DELAY_MS: 100,
} as const;

export const SUGGEST_DROPDOWN_HEIGHT = 300;

export const EMAIL_SUGGESTION_API_CALL = "email_suggestion";

export const FIELD_TYPES = {
    FREE_TEXT: "FreeText",
    SUGGESTIVE_TYPING: "SuggestiveTyping",
    MULTI_SUGGESTIVE_TYPING: "MultiSuggestiveTyping",
    INPUT: "Input",
    DROPDOWN: "DropDown",
} as const;
